import styled from "styled-components"
import { Gender, IRoom } from "../models";
import maleDoctorImg from '../gfx/doctorImages/1.svg';
import femaleDoctorImg from '../gfx/doctorImages/2.svg';

// const DefaultDoctorImage = () => {
//   return (
//     <img src={'https://www.w3schools.com/howto/img_avatar.png'} />
//   )
// }

const DoctorImage = ({ gender }: { gender?: Gender }) => {

  if (gender === Gender.male) {
    return <img alt="" src={maleDoctorImg} style={{backgroundColor: '#415364'}}/>
  } else if (gender === Gender.female) {
    return <img alt=""  src={femaleDoctorImg} style={{backgroundColor: '#415364'}}/>
  } else {
    return <img alt="" src={maleDoctorImg} style={{backgroundColor: '#415364'}}/>
  }
}

const StyledCard = styled.div`
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  cursor: pointer;
  border-radius: 5px;
	width: 200px;

  img {
    max-height:200px;
    width: auto;
    border-radius: 5px 5px 0 0;
  }
`;

const Container = styled.div`
  padding: 2px 16px;
`

export type EmployeeProps = {
  onClick: Function;
  title: string;
  room: IRoom;
  picture?: string;
  gender?: Gender;
}

export const EmployeeCard = (props: EmployeeProps) => {
  return (<>
    <StyledCard onClick={() => props.onClick()}>
      <DoctorImage gender={props.gender} />
      <Container>
        <h4>{props.title}</h4>
        <p>{props.room.displayName ?? "Kontor liksom"}</p>
      </Container>
    </StyledCard>
  </>)
}